import { Outlet, useNavigate } from "react-router";
import { useApp } from "../Context";
import { useEffect } from "react";

export default function AuthRouter(){
    const {auth} = useApp();
    const navigate = useNavigate()
    
    useEffect(()=>{
        if(!auth){
            navigate("login")
        }
    },[auth, navigate])

    return <Outlet/>
}